import React from 'react';
import 'animate.css';
import Icon from '../Components/Icons/Icon';
import { Link } from 'react-router-dom';
import Hud from '../Components/Hud';
import { classNames, deviceIsMd } from '../Services/helpers';
import { useSession } from '../Components/Session';

const content = [
    {
        title: 'Admin',
        items: [
            {
                disabled: true,
                label: 'Website',
                icon: 'GlobePointer',
                to: '/website',
            },
            {
                disabled: true,
                label: 'Account',
                icon: 'User',
                to: '/user',
            },
            {
                // disabled: true,
                label: 'Business',
                icon: 'Building',
                to: '/business/details',
            },
            {
                disabled: true,
                label: 'Payments',
                icon: 'MoneyBillTransfer',
                to: '/manage/payments',
            },
            {
                disabled: true,
                label: 'Messaging',
                icon: 'PaperPlane',
                to: '/manage/messaging',
            },
            {
                // disabled: true,
                label: 'Reports',
                icon: 'ChartSimple',
                to: '/reports',
            },
            {
                label: 'More',
                icon: 'LayerGroup',
                to: '/more',
            }
        ]
    },
    {
        title: 'Manage',
        items: [
            {
                label: 'Customers',
                icon: 'Users',
                to: '/manage/customers',
            },
            {
                label: 'Quotes',
                icon: 'FileInvoice',
                to: '/manage/quotes',
            },
            {
                label: 'Payments',
                icon: 'MoneyBillWave',
                to: '/manage/payments',
            },
            {
                label: 'Expenses',
                icon: 'Receipt',
                to: '/manage/expenses',
            },
            {
                label: 'Broadcasts',
                icon: 'Bullhorn',
                to: '/more/broadcasts',
            },
            {
                label: 'Leads',
                icon: 'UserPlus',
                to: '/plan/leads',
            },
            // {
            //     disabled: true,
            //     label: 'Invoices',
            //     icon: 'FileInvoiceDollar',
            //     to: '/manage/invoices',
            // }
        ]
    },
    {
        title: 'Plan',
        items: [
            {
                label: 'Calendar',
                icon: 'Calendar',
                to: '/calendar',
            },
            {
                label: 'Rounds',
                icon: 'Route',
                to: '/rounds',
            },
            {
                label: 'Jobs',
                icon: 'Toolbox',
                to: '/plan/jobs',
            },
        ]
    },
]

const Switcher = ({ isOpen, setIsOpen }) => {
    const {setShowRedesign, showDarkMode, setShowDarkMode} = useSession();

    return (
        <Hud isOpen={isOpen} onClose={setIsOpen}>
            <div className="flex flex-col gap-4">
                {content.map((row) => <Row key={row.title}
                    {...{title: row.title, items: row.items, close:setIsOpen}}
                />)}

                <div className="flex flex-row w-full items-center justify-between">
                    <button
                        className="mt-4 border border-slate-400 rounded-full text-xs text-slate-400 fill-slate-400 dark:text-slate-200 dark:fill-slate-400 px-4 py-2 hover:bg-white dark:hover:bg-sky-800/60 mx-auto w-fit"
                        onClick={() => setShowRedesign(false)}
                    >
                        Turn off redesign
                    </button>
                    <button
                        className="mt-4 border border-slate-400 rounded-full text-xs text-slate-400 fill-slate-400 dark:text-slate-200 dark:fill-slate-400 px-4 py-2 hover:bg-white dark:hover:bg-sky-800/60 mx-auto w-fit"
                        onClick={() => setShowDarkMode(!showDarkMode)}
                    >
                        <Icon icon={showDarkMode ? 'Sun' : 'Moon'} size="1x" />
                    </button>
                </div>
            </div>
        </Hud>
    );
}

const Row = ({title, items, close}) => {
    return <div className="w-full">
        <h2 className="text-center text-sm text-slate-800 dark:text-slate-200 font-bold md:my-4">{title}</h2>

        <div className="flex flex-row flex-wrap gap-3 md:gap-6 items-stretch justify-around w-full">
            {items.sort((a, b) => a.label.localeCompare(b.label)).map((item) => {
                return <Link key={item.label}
                    title={item.disabled ? 'Coming soon' : ''}
                    className={classNames(
                        'flex flex-col items-center justify-around gap-2 p-2 md:p-4 hover:bg-white/80 dark:hover:bg-sky-800/60 rounded-lg',
                        item.disabled && 'opacity-50 cursor-not-allowed'
                    )}
                    to={item.disabled ? null : item.to}
                    onClick={close}
                >
                    <Icon icon={item.icon} size={deviceIsMd() ? '4x' : '2x'} className="fill-slate-800 dark:fill-slate-200" />
                    <span className="text-xs text-slate-800 dark:text-slate-200 text-center">{item.label}</span>
                </Link>
            })}
        </div>

    </div>
}

export default Switcher;
